// constants
import { IS_DEVELOPMENT_MODE } from '@sitegen/build/config/env/node';
import { LOCAL_FO_CONFIG } from '@sitegen/build/config/fo';
// types
import { IBootstrapConfig } from '@sitegen/common/constants/config';
// services
import { WindowHistoryService } from 'utils/window-history.service';
import i18nService from 'modules/language-provider/i18n.service';
import { UbisoftConnectService } from 'modules/ubisoft-connect-service/service';
import ubisoftOverlayService from 'modules/ubisoft-overlay-service/service';
import { UbisoftAPIService } from 'modules/ubisoft-api';
import { BetaManagerAPIService } from '../widgets/beta-registration/modules/beta-manager/beta-manager-api';
import { FriendsReferralApiService } from '@sitegen/common/classes/friends-referral-api';

/**
 * A function to configure common-to-all-widgets services
 */
export const configureServices = async (
    bootstrapConfig: IBootstrapConfig,
    isPreviewMode: boolean
): Promise<void> => {
    WindowHistoryService.configure({ preview: isPreviewMode, mode: bootstrapConfig.mode });
    /* Return mock data from services when in preview mode. Components should not be aware of these changes */
    if (isPreviewMode) {
        ubisoftOverlayService.configureFakeAPI();
        await UbisoftAPIService.configureFakeAPI();
        await BetaManagerAPIService.configureFakeAPI();
        await FriendsReferralApiService.configureFakeAPI();
        i18nService.setCaching(false);
    }

    configureUbisoftConnectService(bootstrapConfig);
    await configureI18n(bootstrapConfig);
};

/**
 * Configure the i18nService based on the provided widget
 */
const configureI18n = async (config: IBootstrapConfig): Promise<void> => {
    const { initialTranslations, getTranslation } = await import(`../widgets-content/${config.widgetName}/locales`);

    i18nService.init({
        env: config.envName,
        initialTranslations,
        getDefaultTranslationPath: getTranslation
    });
};

const getWebsiteURL = (websiteAbsolutePath: string): string => {
    return IS_DEVELOPMENT_MODE
        ? LOCAL_FO_CONFIG.WHITE_LIST_LOCAL_DOMAIN
        : websiteAbsolutePath;
};

const configureUbisoftConnectService = (bootstrapConfig: IBootstrapConfig) => {
    UbisoftConnectService.configure({
        websiteAbsolutePath: getWebsiteURL(bootstrapConfig.websiteAbsolutePath)
    });
};
